import * as React from 'react';
import TrackVisibility from "react-on-screen";
import Media from 'react-media';

import DataItem from "./DataItem/DataItem";
import PageInfo from "../../../common/PageInfo/PageInfo";
import CarouselGraphics from "../../../common/CarouselGraphics/CarouselGraphics";

import * as styles from './Data.module.scss';

const mediaQueryMinLg = '(min-width: 1232px)';

class Data extends React.Component {
  state = { isWindow: false };

  componentDidMount() {
    this.setState({ isWindow: true })
  }

  render() {
    const { isWindow } = this.state;

    return (
      <section className={styles.root}>
        <div className={styles.containerWrapper}>
          <div className={styles.infoContainer}>
            {isWindow &&
            <Media query={mediaQueryMinLg} key={isWindow}>
              {matches => (
                matches ?
                  <>
                    <div className={styles.ads}>
                      <DataItem title='42 456 400' text='listings' type='splineChart'/>
                    </div>
                    <div>
                      <DataItem title='12 M' text='pageviews' type='columnChart'/>
                    </div>
                  </> :
                  <TrackVisibility partialVisibility={true}>
                    {({ isVisible }) =>
                      <CarouselGraphics isVisible={isVisible} page='data_graphics'>
                        <DataItem title='42 456 400' text='listings' type='splineChart'/>
                        <DataItem title='12 M' text='pageviews' type='columnChart'/>
                      </CarouselGraphics>
                    }
                  </TrackVisibility>
              )}
            </Media>
            }
          </div>
          <PageInfo text={'04 - data'}/>
        </div>
      </section>
    );
  }
}

export default Data;
